import { useCallback as u, cloneElement as f } from "react";
import p from "../../helpers/createTrack.js";
const C = ({ children: n, serviceUrl: l, userId: r, videoId: e, isLiked: t, clientTypeId: a, organizationId: o, extraData: c }) => {
  const m = u((s, i, k) => {
    p(l, {
      ClientTypeId: a,
      UserId: r,
      VideoId: e,
      IsLiked: t,
      Quality: k,
      OrganizationId: o,
      ViewDate: s,
      VideoDuration: i,
      ...c
    });
  }, [r, e, c, o, t, a]);
  return f(n, {
    sendTrack: m,
    videoId: e
  });
};
export {
  C as default
};
